<template>
  <el-table :data="tableData" size="medium" style="width: 100%">
    <el-table-column prop="name" label="名称" width="auto">
      <template slot-scope="scope">
        <router-link to="/BlogDetailIndex">{{scope.row.name}}</router-link>
      </template>
    </el-table-column>
    <el-table-column prop="date" label="创建时间" width="180">
    </el-table-column>
  </el-table>
</template>
<script>
export default {
  name: 'Blogs',
  data () {
    return {
      tableData: [
        {
          date: '2016-05-02',
          name: 'Html5 经典知识',
          redirUrl: 'javascript:;'
        },
        {
          date: '2016-05-04',
          name: 'Html5 语义化标签',
          redirUrl: 'javascript:;'
        },
        {
          date: '2016-05-01',
          name: '自定义布局css笔记',
          redirUrl: 'javascript:;'
        },
        {
          date: '2016-05-03',
          name: 'js常用的代码笔记',
          redirUrl: 'javascript:;'
        }
      ]
    }
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Blogs/index.vue